import { render, staticRenderFns } from "./editMobile.vue?vue&type=template&id=5ffb388e&scoped=true&"
import script from "./editMobile.vue?vue&type=script&lang=js&"
export * from "./editMobile.vue?vue&type=script&lang=js&"
import style0 from "./editMobile.vue?vue&type=style&index=0&id=5ffb388e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb388e",
  null
  
)

export default component.exports